<div class="json-view">
  <a (click)="toggle()" tabindex="0" (keydown.space)="toggle()">
    <span
      class="toggler"
      [ngClass]="{ collapse: isOpen(), expand: !isOpen() }"
      [style.visibility]="hasChildren() ? 'visible' : 'hidden'"></span>
    @if (key()) {
      <span class="key">
        <span>{{ key() }}</span>
        <span>: </span>
      </span>
    }
    <span class="value">
      @if (isObject) {
        <span>
          {{ dataType }}
          @if (isArray) {
            <span>[ {{ $any(data())?.length }} ]</span>
          }
        </span>
      }
      @if (!isObject && valueType) {
        <span [ngClass]="valueType">{{ value }}</span>
      }
    </span>
  </a>
  @if (hasChildren() && isOpen()) {
    <div class="children">
      @for (_key of childrenKeys(); track _key) {
        <ct-extraction-nxt-json-view-item
          [data]="getDataChild(_key)"
          [key]="_key"
          [level]="level() + 1"
          [expansionState]="expansionState()" />
      }
    </div>
  }
</div>
